import styled from 'styled-components';
import Colors from '../../../themes/Colors';

const ImageListHolder = styled.div`
  .container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 10px;
    padding: 20px;
  }
  .content-list {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    display: inline;
    justify-content: center;
  }
  img {
    vertical-align: sub !important;
  }
  h2 {
    color: ${Colors.primaryAccent} !important;
  }

  h4 {
    color: ${Colors.primaryAccent} !important;
  }
  h3 {
    color: ${Colors.textSecondary};
  }
`;

export default ImageListHolder;
